import { FC, memo } from 'react'

import { ArrowRightIcon, Button, Text } from '@cash-me/react-components'
import NextImage from "next/image"

import { Grid, Col } from 'components/grid'
import useWindowSize from 'hooks/useWindowSize'

import { BetterOptionProps } from './better-option.model'
import * as S from './styles'

const BetterOption: FC<BetterOptionProps> = memo(({ onClick }) => {
  const { isTablet } = useWindowSize()

  return (
    <S.Section>
      <Grid col={{ phone: 1, tablet: 2 }}>
        <Col col={{ desktop: 5 }} start={{ desktop: 2 }}>
          <S.MobImg>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/defaulter-mobile.png`}
              alt="Homem sorrindo de braços cruzados"
              width="350"
              height="408"
              priority
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.MobImg>

          <S.DeskImg>
            <NextImage
              src={`${process.env.NEXT_PUBLIC_SITE_IMAGES_PREFIX}/images/site/defaulter/defaulter-desktop.png`}
              alt="Homem sorrindo de braços cruzados"
              width="624"
              height="691"
              priority
              sizes="100vw"
              style={{
                width: "100%",
                height: "auto"
              }} />
          </S.DeskImg>
        </Col>
        <Col col={{ desktop: 5 }} start={{ desktop: 7 }}>
          <S.Infos>
            <Text className="subtitle" size="caption" weight="medium" uppercase>
              Empréstimo para pagamento de dívidas
            </Text>
            <Text as="h2" size="heading3" weight="medium">
              <Text as="span" size="heading3" weight="medium" color="var(--colors-pink-text-default)">
                Qual a melhor opção{' '}
              </Text>
              para Portabilidade de Dívidas?
            </Text>

            <Text color="var(--colors-neutral-text-weak)">
              Se você pensa que a resposta é o banco tradicional, esqueça! A maioria dos bancos não tem interesse em
              ajudar pessoas nessa situação. Conseguir crédito por estas instituições é quase impossível e as taxas são
              absurdamente maiores. Hoje, existem opções criadas, exclusivamente, para quem precisa organizar dívidas e
              regularizar seu nome e CPF.
            </Text>

            <Text color="var(--colors-neutral-text-weak)">
              Uma parceira de soluções financeiras, como a CashMe, é capaz de oferecer o que você precisa para limpar
              seu nome. Tudo isso com a vantagem de ter taxas realmente baixas e atendimento 100% online.
            </Text>
          </S.Infos>

          {isTablet && (
            <Button size="lg" onClick={onClick} variants="default">
              Simular agora <ArrowRightIcon />
            </Button>
          )}
        </Col>
      </Grid>
    </S.Section>
  );
})

BetterOption.displayName = 'BetterOption'

export default BetterOption
